import styled from "styled-components";

interface Props {
  children: React.ReactNode;
  className?: string;
  headerContent?: React.ReactNode;
  heading: string;
}

export const ColumnContainer: React.FC<Props> = ({ children, className, headerContent, heading }) => {
  return (
    <Container className={className}>
      <Header>
        <Heading>{heading}</Heading>
        {headerContent}
      </Header>
      {children}
    </Container>
  );
};

const Container = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
`;

const Heading = styled.h4`
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.1px;
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;
